import React, { useState } from "react";
import { LinePanel, HeaderBar } from "components/containers";
import { ListBuilder, TileGrid, useAuthClaims } from "@redriver/cinnamon";
import { Button } from "semantic-ui-react";
import { PermissionCheck } from "components/auth";
import { claimExists } from "components/auth/utils";
import { Targets, Actions } from "constants/Permissions";
import { ContactTile } from "components/contacts";
import { CustomerTypes } from "constants/enums";
import ContactCard from "assets/icons/contact-card-blue.svg";
import { getCustomerContacts } from "./actions";
import AddCustomerContact from "./AddCustomerContact";
import EditCustomerContact from "./EditCustomerContact";
import DeleteCustomerContact from "./DeleteCustomerContact";

const CustomerContacts = ({ customer, onRefresh }) => {
  const { permissions } = useAuthClaims();
  const canEdit = claimExists(permissions, Targets.Customer, Actions.Edit);

  // The banner shows the primary contact, so it has to reload alongside the grid.
  const refreshContacts = (refresh) => {
    refresh();
    onRefresh();
  };

  const [editId, setEditId] = useState(null);

  return (
    <section style={{ display: "flex" }}>
      <div style={{ flexGrow: 1 }}>
        <ListBuilder
          withTiles
          loadAction={getCustomerContacts}
          loadParams={{ customerId: customer.id }}
          renderList={(tileProps, state, events) => (
            <React.Fragment>
              <LinePanel className="header">
                <HeaderBar
                  name="Contacts"
                  rightContent={
                    <PermissionCheck
                      target={Targets.Customer}
                      action={Actions.Edit}
                    >
                      <AddCustomerContact
                        customerId={customer.id}
                        customerType={customer.type}
                        firstContact={state.total === 0}
                        onRefresh={() => refreshContacts(events.onRefresh)}
                        renderTrigger={(showModal) => (
                          <Button
                            className="compact"
                            content="New Contact"
                            onClick={showModal}
                          />
                        )}
                      />
                    </PermissionCheck>
                  }
                />
              </LinePanel>
              <EditCustomerContact
                modalOpen={!!editId}
                contact={tileProps.data.find((x) => x.id == editId) || {}}
                customerId={customer.id}
                customerType={customer.type}
                closeModal={() => setEditId(null)}
                onRefresh={() => refreshContacts(events.onRefresh)}
              />
              <TileGrid
                {...tileProps}
                dataKey="id"
                wide
                className="card-grid-fill"
                render={(item) => (
                  <ContactTile
                    contact={item}
                    highlight={
                      customer.type == CustomerTypes.Residential
                        ? "faded-green"
                        : "faded-blue"
                    }
                    backgroundUrl={ContactCard}
                    onClick={canEdit ? () => setEditId(item.id) : null}
                    canDelete={canEdit && !item.isMain}
                    renderDeleteContact={(contact) => (
                      <DeleteCustomerContact
                        contact={contact}
                        customerId={customer.id}
                        onDeleted={() => refreshContacts(events.onRefresh)}
                      />
                    )}
                  />
                )}
              />
            </React.Fragment>
          )}
        />
      </div>
    </section>
  );
};

export default CustomerContacts;
